<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <div class="row mb-0" style="margin-top:20px;">
                <div class="py-lg-0 col-md-12">
                    <div class="card cardModuleM h-100">
                        <div class="card-content h-100 d-md-flex align-items-md-center">
                            <div class="row mb-0 no-gutters horizontal-scroll-reports">
                                <div class="col-lg-2 collection listColection">
                                    <a 
                                        v-for="(item, i) in form_system_list" :key="i" 
                                        :class="`collection-item list-colection-item ${form_report_render === item.identify ? 'list-colection-item-selected' : ''}`"
                                        :style="`font-weight:bold; text-decoration:none;`"
                                        v-html="item.name"
                                        :href="`#${item.identify}`"
                                        @click="ReportRenderSecondGen(item.identify, i)"
                                    />
                                </div>
                                <div class="col-lg-10 horizontal-scroll-reports">
                                    <div class="row mb-0 no-gutters">
                                        <div class="col-md-12 py-0 mb-3 mb-md-0">
                                            <div class="input-field my-0">
                                                <i class="material-icons prefix iconInput">search</i>
                                                <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search2">
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="table-responsive mt-1 panel-scroll" style="max-height: 23em">
                                                <table class="table">
                                                    <tbody>
                                                        <tr v-for="(module, index) in display_modules" :key="index">
                                                            <td>
                                                                <input
                                                                    class="ml-3 mt-2 custom-radio custom-control-inline"
                                                                    type="radio"
                                                                    name="select"
                                                                    :value="module"
                                                                    v-model="select"
                                                                    :id="module.name"
                                                                 >
                                                            </td>
                                                            <td v-html="`${module.name} Data`"/>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-0 no-gutters">
                <div class="col-md-12">
                    <div class="modal__buttons text-center text-md-right">
                        <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                        <button class="modal__buttons__item" v-html="`OK`" :class="{'disabled button__disabled' : !select}" :disabled="!select" @click="load_view()"/>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import FormResources   from './form_resources'
import Resources       from './resources'
import Breadcrumb      from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal       from '@/components/BaseModal'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "buildings",
        "breadcrumb",
    ],

    components:{
        Breadcrumb,
        BaseModal,
    },

    data(){
        return{
            form_table_headers:     Resources.form_table_headers,
            form_data:              FormResources.form_data,
            form_format:            FormResources.form_format,
            form_backup:            {...FormResources.form_data},
            form_system_list:       Resources.form_system_list,
            alter_select_all:       false,
            modules:                [],
            form_report_render:     '',
            search2:                '',
            select:                 null
        }
    },

    methods:{

        ReportRenderSecondGen(render, index_position)
        {
            this.form_report_render = render
            this.select = null
            if(index_position === 0)
            {
                let final_modules = []
                this.form_system_list.forEach(item => item.views.length ? item.views.forEach(prop => { final_modules.push(prop) } ) : null)
                this.modules = final_modules
                return true
            }

            this.modules = this.form_system_list[index_position].views
        },

        load_view()
        {
            if(this.select)
            {
                window.location.href = `/new-reports/${this.select.model}`
            }
            
        }
    },

    mounted(){
        this.ReportRenderSecondGen('all', 0)
    },

    computed:
    {
        display_modules()
        {
            return this.search2 ? this.modules.filter(item => item.name.toLowerCase().includes(this.search2.toLowerCase())) : this.modules
        }
    }
    
}
</script>